import { useTranslation } from 'react-i18next';
import './ButtonsStyle.css';

export const YesButton = ({ onClick }) => {
    const { t } = useTranslation();
    return (
        <button className={'button--main success-button yes-no-button'} onClick={onClick}>
            {t('common:buttons.yes')}
        </button>
    );
};